import React, { useState, useEffect, useContext } from 'react';

import { useSDK } from "../../scandit/sdk";
import QRComponent from "../../scandit/QRComponent";

import styles from '../../styles/QRScanner.module.scss';
import {AnimatePresence, motion} from 'framer-motion';
import { useUserAPI } from '../../components/useUserAPI';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import { iAeonSetData } from '../../library/iaeon_sdk.js';

// import useSound from 'use-sound';
// import se_07_scan from '../../sound/s07_scan.mp3';
// import se_08_se from '../../sound/s08_se_delay0.mp3';


function QRScanner(props) {

const { loaded, sdk, error } = useSDK();

// const [se07_scan] = useSound(se_07_scan);
// const [se08_se] = useSound(se_08_se);

// const { onScan, setPage } = props;
const { saleslistAPI, data: saleslistData, loading: saleslistLoading, error: saleslistError } = useUserAPI();
const { payreserveAPI, data: payreserveData, loading: payreserveLoading, error: payreserveError } = useUserAPI();
const { payAPI, data: payData, loading: payLoading, error: payError } = useUserAPI();

//取得バーコード検証用
const [QRcode, setQRcode] = useState('');

const sharedInfo = useContext(SharedInfoContext);
const { exitGateQR, updateExitGateQR } = useContext(SharedInfoContext);
const { signNumber, updateSignNumber } = useContext(SharedInfoContext);
const { registerNumber, updateRegisterNumber } = useContext(SharedInfoContext);
const { frontGateQR, updateFrontGateQR } = useContext(SharedInfoContext);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);

// iOSのバージョンをチェックする関数
// function isiOSVersion16() {
// 	const userAgent = navigator.userAgent || navigator.vendor || window.opera;

// 	// iOSであるかどうかをチェック
// 	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
// 		// iOSのバージョンを抽出
// 		const match = userAgent.match(/OS (\d+)_\d+/);
// 		if (match && match.length > 1) {
// 			const version = parseInt(match[1], 10);
// 			return version === 16;
// 		}
// 	}
// 	return false;
// }


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	// document.documentElement.classList.add('is_fixed');
	// document.body.classList.add('is_fixed');
	document.getElementById('header').classList.add('is_behind');

	// iOS16の場合に特定の処理を行う
	// if (isiOSVersion16()) { //iOS16：スキャンエリア設定
	// 	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
	// 		setTimeout(function(){
	// 			(async () => {
	// 				const scannerArea = document.getElementById("barcode-scanner-area");
	// 				if (scannerArea) {
	// 					const rect = scannerArea.getBoundingClientRect();
	// 					const viewRect = document.getElementById("barcode-scanner").getBoundingClientRect();
	// 					await sdk.setScanArea(rect,viewRect);
	// 				}
	// 			})();
	// 		}, 600);
	// 	}else { //iAEON無効
	// 	}
	// } else { //スキャンエリア設定
	// 	setTimeout(function(){
	// 		(async () => {
	// 			const scannerArea = document.getElementById("barcode-scanner-area");
	// 			if (scannerArea) {
	// 				const rect = scannerArea.getBoundingClientRect();
	// 				const viewRect = document.getElementById("barcode-scanner").getBoundingClientRect();
	// 				await sdk.setScanArea(rect,viewRect);
	// 			}
	// 		})();
	// 	}, 600);
	// }

	// if(props.appHeight !== ""){
	// 	let element2 = document.getElementById('qrscan');
	// 	if(element2){
	// 		element2.style.height = props.appHeight + 'px';
	// 	}
	// }else {
		//arrows We 対応
		// document.documentElement.style.zoom = window.innerWidth / 390;
		// var zratio = window.innerWidth / 390;
		if(window.innerWidth >= 320){
			document.documentElement.style.zoom = window.innerWidth / 390;
			var zratio = window.innerWidth / 390;
		}else{
			document.documentElement.style.zoom = 1;
			var zratio = 1;
		}
		let hratio = window.innerHeight / (window.innerHeight * zratio);
		let realheight = window.innerHeight * hratio;
		let elementA = document.getElementById('qrscan');
		if (elementA) {
			elementA.style.height = realheight + 'px';
		}
	// }
}, []);


//----------------------------------------
//初回QR
//----------------------------------------

const [firstQR, setFirstQR] = useState(true);

useEffect(() => {
	if(firstQR === true){
		setFirstQR(false);
	}else{
		console.log("props.scanFlg: " + props.scanFlg);
		// props.scanFlg true: スキャン不可 false:スキャン可
		if(props.scanFlg === false && firstQR === false){
			(async () => {
				setQRcode('');
				if (loaded) {
					// await sdk.enableScanning(true);
					// await sdk.enableCamera(false);
					try {
						await sdk.enableScanning(true);
					} catch (e) {
						console.error("enableScanning failed:", e);

						// ユーザー向け表示
						props.setErrFlg(true);
						let err_msg = ";;"+e+";;;";
						props.setErr([true,``, err_msg]);

						// 再トライ暴発を避けたい場合はスキャン不可に戻す（任意）
						// props.setScanFlg(true);

						//ログアップロードAPI
						loguploadAPI(sharedInfo.transactionno, `scandit:enableScanning error, ${e}`);
					}
				}
			})();
		}
	}
}, [props.scanFlg]);


//----------------------------------------
//QRコード取得
//----------------------------------------

const [isApiCall, setIsApiCall] = useState(true);

useEffect(() => {
	console.log("QRcode: " + QRcode);
	console.log("isApiCall: " + isApiCall);
	if(QRcode !== ''){
	if (QRcode && isApiCall) {
		setIsApiCall(false);

		console.log("【売上一覧取得API call】---------------------------");
		saleslistAPI();

		const timer = setTimeout(() => {
			setIsApiCall(true);
		}, 1000);

		return () => clearTimeout(timer);
	}else {
		console.log("【売上一覧取得API call】再呼び出し制限中");
	}
	}
}, [QRcode]);

// useEffect(() => {
// 	if(QRcode){
// 		if(QRcode !== ''){
// 			saleslistAPI();
// 			//二重送信対応テスト
// 			//saleslistAPI();
// 		}
// 	}
// }, [QRcode]);


//----------------------------------------
//scanditエラー表示
//----------------------------------------

useEffect(() => {
	if(String(error).indexOf("NotAllowedError: Permission denied") !== -1){
		console.log("error: " + error);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_SCANDIT_NOTALLOW]);
		// props.setErr([true,``,`;;カメラの利用が許可されていません;;;`]);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"scandit:error, " + error);

	}else if(String(error) !== "undefined" && String(error) !== undefined && String(error) !== ""){
		console.log("error: " + error);
		props.setErrFlg(true);
		let err_msg = ";;"+error+";;;";
		props.setErr([true,``, err_msg]);
		// props.setErr([true,``,`;;カメラの利用が許可されていません;;;`]);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"scandit:error, " + error);
	}
}, [error]);


//----------------------------------------
//ログアップロードAPI
//----------------------------------------

const { loguploadAPI, data: loguploadData, loading: loguploadLoading, error: loguploadError } = useUserAPI();

//ログアップロードAPI：レスポンス
useEffect(() => {
	if(loguploadData){
		console.log(loguploadData);
		if (loguploadData.isSuccess == true) { //SUCCESS
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
		}else{ //ERROR
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
			console.log(`【loguploadAPI】 errorCode: ${loguploadData.errorCode}`);
			console.log(`【loguploadAPI】 errorMessage: ${loguploadData.errorMessage}`);
		}
	}
}, [loguploadData]);


//----------------------------------------
//売上一覧取得API レスポンス取得
//----------------------------------------

useEffect(() => {
	// console.log("useEffect purchaseData");
	if(saleslistData){
		if (saleslistData.data) { //SUCCESS

			//無効
			// if(barcodeCapture){
			// 	barcodeCapture.removeListener(listener);
			// 	barcodeCapture.setEnabled(false);
			// }
			// setTimeout(function(){
			// 	if(barcodeCapture){
			// 		barcodeCapture.removeListener(listener);
			// 		barcodeCapture.setEnabled(false);
			// 	}
			// }, 2200);

			// se07_scan();
			props.setSoundState("se07_scan");

			console.log(`【saleslistAPI】 sumIncludeTaxPrice: ${saleslistData.data.sumIncludeTaxPrice}`);
			console.log(`【saleslistAPI】 sumSellPrice: ${saleslistData.data.sumSellPrice}`);
			console.log(`【saleslistAPI】 sumItemCount: ${saleslistData.data.sumItemCount}`);

			//売上一覧：明細用
			props.setSaleData(saleslistData);

			console.log("QRコード判定（先頭2桁）: " + QRcode.substring(0, 2));
			if(QRcode.substring(0, 2) === "79"){ //代表レジ
				console.log("代表レジ");
				console.log(`【payreserveAPI】 registerNumber: ${QRcode}`);
				//ログアップロードAPI
				loguploadAPI(sharedInfo.transactionno,"payreserveAPI:otb, code:" + props.otb);

				payreserveAPI(QRcode,props.otb);
				//二重送信対応テスト
				//payreserveAPI(QRcode,props.otb);

				//「QRスキャン戻るボタン」無効
				setIsQRScanBack(false);

			}else{ //専用レジ（個別レジ）・有人レジ
				console.log("専用レジ（個別レジ）・有人レジ");
				// const QRcode = "770000082900008730000009";
				// 15、16、17番目の文字を抽出
				const reginum = QRcode.substring(14, 17);
				console.log(`【payAPI】 registerNumber: ${reginum}`);
				updateRegisterNumber(reginum);
				//ログアップロードAPI
				loguploadAPI(sharedInfo.transactionno,"payAPI:otb, code:" + props.otb);

				payAPI(QRcode,props.otb);
				//二重送信対応テスト
				//payAPI(QRcode,props.otb);

				//「QRスキャン戻るボタン」無効
				setIsQRScanBack(false);
			}
			// payreserveAPI("790000008290000001000005");

			// props.setShoppingData(shoppingPurchaseData);
			// props.setShoppingData(saleslistData);
			// setScanItem(true);
			// setTimeout(function(){
			// 	setScanItem(false);
			// 	props.setPage("shopping");
			// }, 3000);
		}else{ //ERROR
			console.log(`【saleslistAPI】 errorCode: ${saleslistData.errorCode}`);
			console.log(`【saleslistAPI】 errorMessage: ${saleslistData.errorMessage}`);
			console.log(`【saleslistAPI】 isSuccess: ${saleslistData.isSuccess}`);

			// setTimeout(function(){
			// 	if(barcodeCapture){
			// 		barcodeCapture.removeListener(listener);
			// 		barcodeCapture.setEnabled(false);
			// 	}
			// }, 2200);

			if(saleslistData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${saleslistData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(saleslistData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${saleslistData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else if(saleslistData.errorCode === "32"){//フロントチェックエラー
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`,`${saleslistData.errorMessage}`]);
			}else{
				// props.setErrNum(`${saleslistData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${saleslistData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${saleslistData.errorCode}`,`${saleslistData.errorMessage}`]);

				//有効
				// setTimeout(function(){
				// 	if(barcodeCapture){
				// 		// barcodeCapture.addListener(listener);
				// 		barcodeCapture.setEnabled(true);
				// 	}
				// }, 2200);
			}
		}
	}
	if(saleslistError){
		console.log("saleslistError");
		console.log(saleslistError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	// if(saleslistLoading){
	// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
	// 		element.classList.add('is_show');
	// 	});
	// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
	// 		element.classList.add('is_show');
	// 	});
	// }else{
	// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
	// 		element.classList.remove('is_show');
	// 	});
	// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
	// 		element.classList.remove('is_show');
	// 	});
	// }
}, [saleslistData,saleslistLoading,saleslistError]);


//----------------------------------------
//決済予約API：代表レジ レスポンス取得
//----------------------------------------

useEffect(() => {
	// console.log("useEffect purchaseData");
	if(payreserveData){
		if (payreserveData.data) { //SUCCESS
			console.log(`【payreserveAPI】 qrcode: ${payreserveData.data.qrcode}`);
			console.log(`【payreserveAPI】 signNumber: ${payreserveData.data.signNumber}`);
			console.log(`【payreserveAPI】 registerNumber: ${payreserveData.data.registerNumber}`);
			if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
				console.log(`【payreserveAPI】 dammingFlag: ${payreserveData.data.dammingFlag}`);
			}

			// if(payreserveData.data.qrcode === "999"){ //有人レジ
			if(QRcode.substring(12, 14) === "01"){ //有人レジ
				console.log("有人レジへ");
			}else if(QRcode.substring(12, 14) === "02"){ //兼用セルフ（有人レジと同じ挙動
				console.log("有人レジへ（兼用セルフ");
			}else if(payreserveData.data.qrcode === null){ //代表レジ 待ちなし精算確認APIへ
				console.log("代表レジ 待ちなし算確認APIへ");
			}else{ //代表レジ 待ちあり精算確認APIへ
				console.log("代表レジ 待ちあり精算確認APIへ");
			}
			updateExitGateQR(payreserveData.data.qrcode);
			updateSignNumber(payreserveData.data.signNumber);
			updateRegisterNumber(payreserveData.data.registerNumber);
			setScanItem(true);


			setTimeout(function(){
				// document.getElementById('qrtxt').classList.add("is_hide");
				setQrtxtHide(true);
			}, 1000);
			setTimeout(function(){
				setScanItem(false);
				if(props.page === "qrscan"){
					console.log(QRcode.substring(0, 2));
					if(QRcode.substring(0, 2) === "79"){ //代表レジ
						if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
							if(payreserveData.data.dammingFlag === "1"){ //せき止めON
								goRegiSenyou(true);
							}else{ //せき止めOFF
								goRegiSenyou(false);
							}
						}else{ //せき止め無効
							goRegiSenyou(false);
						}
					}else{ //専用レジ（個別レジ）・有人レジ
						// if(exitGateQR === "999"){ //有人レジ
						console.log("QRcode.substring(12, 14): "+QRcode.substring(12, 14));
						if(QRcode.substring(12, 14) === "01"){ //有人レジ
							goRegiYujin();
						}else if(QRcode.substring(12, 14) === "02"){ //兼用セルフ（有人レジと同じ挙動
							goRegiYujin();
						}else{ //専用レジ（個別レジ）へ
							goRegiSelf();
						}
					}
				}
			}, 2000);

			// console.log("【sharedInfo】 gateFlag:"+sharedInfo.gateFlag);
			// if(sharedInfo.gateFlag == "1"){ //ゲート対象ON
			// 	if(payreserveData.data.qrcode === "999"){ //有人レジ

			// 	}else if(payreserveData.data.qrcode === null){ //決済確認APIへ

			// 		updateExitGateQR(payreserveData.data.qrcode);
			// 		updateSignNumber(payreserveData.data.signNumber);
			// 		updateRegisterNumber(payreserveData.data.registerNumber);
			// 		setScanItem(true);
			// 	}else{ //正常

			// 		updateExitGateQR(payreserveData.data.qrcode);
			// 		updateSignNumber(payreserveData.data.signNumber);
			// 		updateRegisterNumber(payreserveData.data.registerNumber);
			// 		setScanItem(true);
			// 	}
			// }else{ //ゲート非対称OFF
			// 	if(payreserveData.data.qrcode === "999"){ //有人レジ
			// 		console.log("有人レジへ");
			// 	}else{ //決済確認APIへ
			// 		console.log("専用レジ（個別レジ）へ");
			// 		updateExitGateQR(payreserveData.data.qrcode);
			// 		updateSignNumber(payreserveData.data.signNumber);
			// 		updateRegisterNumber(payreserveData.data.registerNumber);
			// 		setScanItem(true);
			// 	}
			// }
		}else{ //ERROR
			console.log(`【payreserveAPI】 errorCode: ${payreserveData.errorCode}`);
			console.log(`【payreserveAPI】 errorMessage: ${payreserveData.errorMessage}`);
			console.log(`【payreserveAPI】 isSuccess: ${payreserveData.isSuccess}`);

			//「QRスキャン戻るボタン」有効
			setIsQRScanBack(true);

			if(payreserveData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payreserveData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${payreserveData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payreserveData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${payreserveData.errorCode}`,`${payreserveData.errorMessage}`]);
				console.log("エラー32：フロントチェックエラー");
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${payreserveData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${payreserveData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${payreserveData.errorCode}`,`${payreserveData.errorMessage}`]);

				//有効
				// setTimeout(function(){
				// 	if(barcodeCapture){
				// 		// barcodeCapture.addListener(listener);
				// 		barcodeCapture.setEnabled(true);
				// 	}
				// }, 2200);
			}
		}
	}
	if(payreserveError){ //通信エラー・タイムアウト（緑ルート
		console.log("payreserveError");
		console.log(payreserveError);
		// props.setErrFlg(true);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		console.log("タイムアウト（ノーレスポンス）・通信エラーのため、エラー35画面へ");
		// props.setTimeoutCountFlg(true);
		// props.setPage("regi_self");
		props.setPage("error_35");
	}
	// if(payreserveLoading){
	// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
	// 		element.classList.add('is_show');
	// 	});
	// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
	// 		element.classList.add('is_show');
	// 	});
	// }else{
	// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
	// 		element.classList.remove('is_show');
	// 	});
	// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
	// 		element.classList.remove('is_show');
	// 	});
	// }
}, [payreserveData,payreserveLoading,payreserveError]);


//----------------------------------------
//決済API：専用レジ（個別レジ）・有人レジ レスポンス取得
//----------------------------------------

useEffect(() => {
	// console.log("useEffect purchaseData");
	if(payData){
		if (payData.data) { //SUCCESS
			console.log(`【payAPI】 qrcode: ${payData.data.qrcode}`);

			// if(payData.data.qrcode === "999"){ //有人レジ
			if(QRcode.substring(12, 14) === "01"){ //有人レジ
				console.log("有人レジへ");
			}else if(QRcode.substring(12, 14) === "02"){ //兼用セルフ（有人レジと同じ挙動
				console.log("有人レジへ（兼用セルフ");
			}else if(payData.data.qrcode === null){ //専用レジ（個別レジ）待ちなし精算確認APIへ
				console.log("専用レジ（個別レジ）待ちなし算確認APIへ");
			}else{ //専用レジ（個別レジ）待ちあり精算確認APIへ
				console.log("専用レジ（個別レジ）待ちあり精算確認APIへ");
			}
			updateExitGateQR(payData.data.qrcode);
			setScanItem(true);


			setTimeout(function(){
				// document.getElementById('qrtxt').classList.add("is_hide");
				setQrtxtHide(true);
			}, 1000);
			setTimeout(function(){
				setScanItem(false);
				if(props.page === "qrscan"){
					console.log(QRcode.substring(0, 2));
					if(QRcode.substring(0, 2) === "79"){ //代表レジ
						//せき止め無効
						goRegiSenyou(false);
					}else{ //専用レジ（個別レジ）・有人レジ
						// if(exitGateQR === "999"){ //有人レジ
						console.log("QRcode.substring(12, 14): "+QRcode.substring(12, 14));
						if(QRcode.substring(12, 14) === "01"){ //有人レジ
							goRegiYujin();
						}else if(QRcode.substring(12, 14) === "02"){ //兼用セルフ（有人レジと同じ挙動
							goRegiYujin();
						}else{ //専用レジ（個別レジ）へ
							goRegiSelf();
						}
					}
				}
			}, 2000);


		}else{ //ERROR
			console.log(`【payAPI】 errorCode: ${payData.errorCode}`);
			console.log(`【payAPI】 errorMessage: ${payData.errorMessage}`);
			console.log(`【payAPI】 isSuccess: ${payData.isSuccess}`);

			//「QRスキャン戻るボタン」有効
			setIsQRScanBack(true);

			if(payData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${payData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${payData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
				// console.log("エラー32：フロントチェックエラー");
				// props.setPage("error_32");
			}else if(payData.errorCode === "32"){//フロントチェックエラー
				// props.setErrFlg(true);
				// props.setErr([true,`${payData.errorCode}`,`${payData.errorMessage}`]);
				console.log("エラー32：フロントチェックエラー");
				props.setPage("error_32");
			}else{
				// props.setErrNum(`${payData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${payData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${payData.errorCode}`,`${payData.errorMessage}`]);

				//有効
				// setTimeout(function(){
				// 	if(barcodeCapture){
				// 		// barcodeCapture.addListener(listener);
				// 		barcodeCapture.setEnabled(true);
				// 	}
				// }, 2200);
			}
		}
	}
	if(payError){ //通信エラー・タイムアウト（緑ルート
		console.log("payError");
		console.log(payError);
		// props.setErrFlg(true);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		console.log("タイムアウト（ノーレスポンス）・通信エラーのため、エラー35画面へ");
		// props.setTimeoutCountFlg(true);
		// props.setPage("regi_self");
		props.setPage("error_35");
	}
	// if(payLoading){
	// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
	// 		element.classList.add('is_show');
	// 	});
	// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
	// 		element.classList.add('is_show');
	// 	});
	// }else{
	// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
	// 		element.classList.remove('is_show');
	// 	});
	// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
	// 		element.classList.remove('is_show');
	// 	});
	// }
}, [payData,payLoading,payError]);


//----------------------------------------
//ページ遷移
//----------------------------------------

//「QRスキャン戻るボタン」の抑制フラグ true：戻るボタン有効 false：戻るボタン無効
const [isQRScanBack, setIsQRScanBack] = useState(true);

const onScanClose = () => {
	if(isQRScanBack !== false){
		(async () => {
			if (loaded) {
				await sdk.enableScanning(false);
				await sdk.enableCamera(false);
			}
		})();
		setScanItem(false);
		props.setPage("shopping");
		// se08_se();
		props.setSoundState("se08_se");
	}
}

//代表レジ
const goRegiSenyou = (dammingFlg) => {
	(async () => {
		if (loaded) {
			await sdk.enableScanning(false);
			await sdk.enableCamera(false);
		}
	})();
	props.setRegiType("regi_senyou");

	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//データ保存API（買物データ削除
		callAPI_18_delete();
	}

	if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
		if(dammingFlg === true){ //せき止めON
			props.setPage("front_check");
		}else{ //せき止めOFF
			props.setPage("regi_senyou");
		}
	}else{ //せき止め無効
		props.setPage("regi_senyou");
	}
}

//専用レジ（個別レジ
const goRegiSelf = () => {
	(async () => {
		if (loaded) {
			await sdk.enableScanning(false);
			await sdk.enableCamera(false);
		}
	})();
	props.setRegiType("regi_self");

	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//データ保存API（買物データ削除
		callAPI_18_delete();
	}

	// if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
	// 	props.setPage("front_check");
	// }else{ //せき止め無効
	// 	props.setPage("regi_self");
	// }
	props.setPage("regi_self");
}

//有人レジ
const goRegiYujin = () => {
	(async () => {
		if (loaded) {
			await sdk.enableScanning(false);
			await sdk.enableCamera(false);
		}
	})();
	props.setRegiType("regi_yujin");

	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//データ保存API（買物データ削除
		callAPI_18_delete();
	}

	// if(process.env.REACT_APP_FRONT_CHECK === "true"){ //せき止め有効
	// 	props.setPage("front_check");
	// }else{ //せき止め無効
	// 	props.setPage("regi_yujin");
	// }
	props.setPage("regi_yujin");
}

const [scanItem, setScanItem] = useState(false)


//----------------------------------------
//アニメーション設定
//----------------------------------------

const motionConfig = {
	initial: {
		// y: -20,
		y: 0,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		// y: 20,
		y: 0,
		opacity: 0,
	},
};

const [qrtxtHide, setQrtxtHide] = useState(false);


//----------------------------------------
//データ保存API（買物データ削除
//----------------------------------------

//18.データ保存API（買物データ削除
function callAPI_18_delete(){
	console.log("----------------------------");
	console.log("【iAeonSetData】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData】success：');
		console.log(aaa);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData】error: ' + error.error_code + " : " + error.message);
		console.log(bbb);
    }
    // window.iAeonMiniApp.iAeonSetData({"mode":"add", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
    // window.iAeonMiniApp.iAeonSetData({"mode":"put", "key": "shopping_data", "value": shoppingJSON}).then(successCall_18).catch(errorCall_18);
	iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
	// window.iAeonMiniApp.iAeonSetData({"mode":"delete", "key": "shopping_data"}).then(successCall_18).catch(errorCall_18);
}


return (
<div id="qrscan" className="container l_contents">

<header id="header02" className={`l_header02 ${bandColor}`}>
	<button href="" className={`header02_backBtn ${isQRScanBack ? "" : "is_disabled"}`} onClick={onScanClose}>
		<img src="/images/icn_back01_white.svg" alt="" width="24" height="24"/>
	</button>
	<p className="header02_tit">お支払い中</p>
</header>

{/* <!--- #qrScanBox ---> */}

<div id="qrScanBox" className={styles.qrScanBox}>
	<p id="qrtxt" className={`${styles.qrScanBox_tit} ${qrtxtHide ? styles.is_hide : ''}`}>お支払いコードをスキャン</p>
	<p className={styles.qrScanBox_txt}>
		<span className={styles.qrScanBox_stit}>スキャン忘れの<br />商品はございませんか？</span>
		従業員が商品点数を<br />確認させていただくことがございます
	</p>
	<div id="barcode-scanner-area" className={styles.qrScanArea}></div>
	<div className={styles.qrScanCover}></div>
	<div id="barcode-scanner" className={`${styles.scanImg} ${styles.scanImg02}`}></div>
	<QRComponent setQRcode={setQRcode} setScanFlg={props.setScanFlg}/>
	<AnimatePresence>
		{scanItem && (
			<motion.p id="addItem" className={styles.qrScan_success}
			initial={'initial'}
			animate={'animate'}
			exit={'hidden'}
			variants={motionConfig}
			transition={{duration: 0.4, ease: 'easeOut'}}
			>
				{/* <span>
					<span className={styles.qrScan_success_check}>
						<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
					</span>
					お支払いコードを読み取りました
				</span> */}
				<span className={styles.qrScan_success01}>
					<span className={styles.qrScan_success_check}>
						<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
					</span>
					お支払いコードを読み取りました
				</span>
				<span className={styles.qrScan_success02}>
					<span className={styles.qrScan_success_spinner}>
						<img src="/images/loading_spinner.png" alt="" width="24" height="24" />
					</span>
					レジへ送信しています
				</span>
				{/* {
					(() => {
						setTimeout(function(){
							setQrtxtHide(true);
						}, 1000);
						setTimeout(function(){
							setScanItem(false);
							if(props.page === "qrscan"){
								console.log(QRcode.substring(0, 2));
								if(QRcode.substring(0, 2) === "79"){ //代表レジ
									goRegiSenyou();
								}else{ //専用レジ（個別レジ）・有人レジ
									// if(exitGateQR === "999"){ //有人レジ
									console.log("QRcode.substring(12, 14): "+QRcode.substring(12, 14));
									if(QRcode.substring(12, 14) === "01"){ //有人レジ
										goRegiYujin();
									}else if(QRcode.substring(12, 14) === "02"){ //兼用セルフ（有人レジと同じ挙動
										goRegiYujin();
									}else{ //専用レジ（個別レジ）へ
										goRegiSelf();
									}
								}
							}
						}, 2000);
					})()
				} */}
			</motion.p>
		)}
	</AnimatePresence>
</div>

</div>
	)
}

export default QRScanner;
